import { Box, Typography, Link, Button } from "@mui/material";
import React from "react";
import { GoMarkGithub } from "react-icons/go";
import { BsLinkedin } from "react-icons/bs";
import { FaRegEnvelope } from "react-icons/fa";
import { FaTwitter } from 'react-icons/fa';
import Typewriter from "typewriter-effect";
import { keyframes, styled } from "@mui/material";
import Developer from '../Tech Stacks Images/MERN-Stack-Developer.png'




let intro = keyframes`
0%{
  transform : translateX(-800px)
}
100%{
  transform : translateX(0px)
}
`;

let devImage = keyframes`
0%{
  transform : translateY(-600px)
}
100%{
  transform : translateY(0px)
}
`;

let Intro = styled(Box)(() => ({
  animation: `${intro} 1.5s ease-out`,
}));

let DevImage = styled(Box)(() => ({
  animation: `${devImage} 1.5s ease-out`,
}));

function Home() {


  let Colors = [
    "FF4D00",
    "FFBC00",
    "FFEF00",
    "D5FF00",
    "F2232A",
    "1599A8",
    "E80D0D",
    "DF4DAA",
    "6F0649",
    "0AAE4B",
    "1EF5C3",
    "3B93A5",
    "FFBC00",
    "FFEF00",
    "D5FF00",
    "F2232A",
    "A817DC",
    "DC17C2",
    "DC178E",
    "E668B4",
    "E66892",
    "F2232A",
    "1599A8",
    "E80D0D",
    "DF4DAA",
    "6F0649",
    "64066F",
    "D10DE6",
    "0DE6E6",
    "247052",
    "98CB0B",
    "CB780B"
  ];
  let [color, setColor] = React.useState("white");
  let [index, setIndex] = React.useState(0);
  React.useEffect(() => {
    let x = setInterval(() => {
      setColor(Colors[index]);
      setIndex(index++);
      if (index === Colors.length) {
        index = 0;
      }
    }, 1000);
    let cleanup = () => clearInterval(x);
    return cleanup;
  }, []);


  return (
    <Box
    sx={{
      width: "100vw",
      height: {lg:'100vh',md:'100vh',sm:'auto',xs:'auto'},
      display: "flex",
      backgroundColor:'black',
      flexDirection: {
        lg: "row",
        md: "row",
        sm: "column-reverse",
        xs: "column-reverse",
      },
      justifyContent: "space-around",
      alignItems: { lg: "center", sm: "center", xs: "center" },
      gap: { sm: "30px", xs: "30px" },
      lineHeight: "1",
      textAlign: { lg: "left", md: "left" },
      color: "white",
      margin: "auto",
      padding: {
        lg: "28px 0px 0px",
        md: "255px 0px",
        sm: "50px 20px 50px",
        xs: "50px 20px",
      },
      boxSizing: "border-box"
    }}
    >
      <Intro
        sx={{
          marginTop: { lg: "0px", md: "40px", sm: "0px", xs: "0px" },
          marginLeft: { lg: "30px" },
        }}
      >
        <Typography
          sx={{
            fontSize: { lg: "18px", md: "15px", sm: "18px", xs: "15px" },
            color: "teal",
            fontWeight: { lg: 500, md: 500 },
            transition: "1s",
            marginTop: { lg: "25px", md: "40px", sm: "30px", xs: "25px" },
          }}
        >
          Hello everyone, my name is
        </Typography>
        <Typography
          sx={{
            fontSize: { lg: "75px", md: "55px", sm: "45px", xs: "35px" },
            marginLeft: { lg: "-6px", md: "-6px" },
            fontWeight: { lg: 600, md: 400, sm: 500, xs: 500 },
            letterSpacing: { lg: 3, md: "5px", sm: "5px", xs: "5px" },
            color: "white",
            transition: "1s",
          }}
        >
          Pranay Khadse
        </Typography>
        <Typography
          sx={{
            fontSize: { lg: "22.5px", md: "20px", sm: "20px", xs: "17px" },
            letterSpacing: {
              lg: "10.7px",
              md: "6.7px",
              sm: "4.5px",
              xs: "3.5px",
            },
            fontWeight: { lg: 600, md: 400, sm: 400, xs: 400 },
            transition: "1s",
            marginLeft: { md: "-2px", sm: "-2px", xs: "-2px" },
            color: `#${color}`,
            textAlign: "center",
          }}
        >
          <Typewriter
            options={{
              autoStart: true,
              delay: 40,
              strings: ["MERN Stack Web Developer", "A Passionate Coder"],
              loop: true,
            }}
          />
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { lg: "row", md: "row", sm: "column", xs: "column" },
            justifyContent: {
              lg: "space-between",
              md: "space-between",
              sm: "space-between",
              xs: "space-between",
            },
            alignItems: "center",
            transition: "1s",
            marginLeft: { lg: "-3px", md: "-5px" },
            padding: { sm: "50px 0px", xs: "50px 0px" },
            gap: { sm: "5px", xs: "5px" }
          }}
        >
          <Link
            href="https://twitter.com/PranayKhadse20"
            sx={{ textDecoration: "none" }}
          >
            <Button
              sx={{
                backgroundColor: "#0080FF",
                display: "flex",
                gap: { lg: "10px", md: "4px", sm: "10px", xs: "10px" },
                color: "white",
                fontSize: { lg: "15px", md: "12px", sm: "13px", xs: "13px" },
                borderRadius: "10px",
                fontWeight: { lg: 500, md: 300, sm: 400, xs: 400 },
                width: { lg: "110px", md: "90px", sm: "340px", xs: "280px" },
                height: { lg: "40px", md: "35px", sm: "35px", xs: "35px" },
                cursor: "pointer",
                border: "none",
                marginLeft: { sm: "-4px", xs: "-4px" },
                marginBottom:{sm:'10px',xs:'10px'},
                ":hover":{backgroundColor:'#003366'}
              }}
            >
              <FaTwitter />
              Twitter
            </Button>
          </Link>
          <Link
            href="https://github.com/khadsepranay"
            sx={{ textDecoration: "none" }}
          >
            <Button
              sx={{
                backgroundColor: "#5E5E5E",
                display: "flex",
                gap: { lg: "10px", md: "4px", sm: "10px", xs: "10px" },
                color: "white",
                fontSize: { lg: "15px", md: "12px", sm: "13px", xs: "13px" },
                borderRadius: "10px",
                fontWeight: { lg: 500, md: 300, sm: 400, xs: 400 },
                width: { lg: "110px", md: "90px", sm: "340px", xs: "280px" },
                height: { lg: "40px", md: "35px", sm: "35px", xs: "35px" },
                cursor: "pointer",
                border: "none",
                marginLeft: { sm: "-4px", xs: "-4px" },
                marginBottom:{sm:'10px',xs:'10px'},
                ":hover":{backgroundColor:'#202020'}
              }}
            >
              <GoMarkGithub />
              GitHub
            </Button>
          </Link>
          <Link
            href="https://mail.google.com/mail/u/0/?fs=1&to=pranitkhadse20@gmail.com&su=SUBJECT&body=BODY&tf=cm"
            sx={{ textDecoration: "none" }}
          >
            <Button
              sx={{
                backgroundColor: "#FF3333",
                display: "flex",
                gap: { lg: "10px", md: "4px", sm: "10px", xs: "10px" },
                color: "white",
                fontSize: { lg: "15px", md: "12px", sm: "13px", xs: "13px" },
                borderRadius: "10px",
                fontWeight: { lg: 500, md: 300, sm: 400, xs: 400 },
                width: { lg: "110px", md: "90px", sm: "340px", xs: "280px" },
                height: { lg: "40px", md: "35px", sm: "35px", xs: "35px" },
                cursor: "pointer",
                border: "none",
                marginLeft: { sm: "-4px", xs: "-4px" },
                marginBottom:{sm:'10px',xs:'10px'},
                ":hover":{backgroundColor:'#990000'}
              }}
            >
              <FaRegEnvelope />
              G-Mail
            </Button>
          </Link>
          <Link
            href="https://www.linkedin.com/in/pranay-khadse-b2ba86179/"
            sx={{ textDecoration: "none" }}
          >
            <Button
              sx={{
                backgroundColor: "#0066CC",
                display: "flex",
                gap: { lg: "10px", md: "4px", sm: "10px", xs: "10px" },
                color: "white",
                fontSize: { lg: "15px", md: "12px", sm: "13px", xs: "13px" },
                borderRadius: "10px",
                fontWeight: { lg: 500, md: 300, sm: 400, xs: 400 },
                width: { lg: "110px", md: "90px", sm: "340px", xs: "280px" },
                height: { lg: "40px", md: "35px", sm: "35px", xs: "35px" },
                cursor: "pointer",
                border: "none",
                marginLeft: { sm: "-4px", xs: "-4px" },
                marginBottom:{sm:'10px',xs:'10px'},
                ":hover":{backgroundColor:'#003366'}
              }}
            >
              <BsLinkedin />
              LinkedIn
            </Button>
          </Link>
        </Box>
      </Intro>
      <DevImage
        component="img"
        src={Developer}
        sx={{
          width: { lg: "550px", md: "400px", sm: "420px", xs: "300px" },
          height: { lg: "400px", md: "290px", sm: "310px", xs: "200px" },
          transition: "1s",
          marginTop: { lg: "-50px", md: "0px", sm: "50px", xs: "50px" },
        }}
      ></DevImage>
    </Box>
  );
}

export default Home;
